// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import Vant from 'vant';
// import 'vant/lib/index.css';
import { Dialog } from 'vant';
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.js'
import App from './App'
import router from './router'
import axios from 'axios'
Vue.prototype.$axios = axios
import './static/css/app.css'
import './static/css/icons.css'
import Config from './components/Config'
import store from './store'
Vue.prototype.$store = store
import {USER_LOGIN} from './store/types'
import Page from './components/UnvPage.vue'
import NavBar from './components/NavBar.vue'
// import FormItem from './components/FormItem.vue'
// import GridView from './components/GridView.vue'
// import GridItem from './components/GridItem.vue'
// import AdView from './components/AdView.vue'
import api from './components/api'
import './assets/css/main_audio.css'; 
import './assets/js/jaudio.js'
// import './assets/js/jquery-3.2.1.min.js'
// import './assets/js/jquery.min.js'
// import './assets/js/echarts.min'
// import Vconsole from 'vconsole';
// new Vconsole();
// import Navigation from './components/navigation/'
import $ from 'jquery'

// ================================= UI框架 ================================= //
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
import 'vue-ydui/dist/ydui.flexible';
Vue.use(YDUI);
// Vue.use(Vant);
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
import particles from 'particles.js'
Vue.use(particles)
Vue.prototype.$dialog = Dialog
Vue.prototype.$showDialog = function (show = true, text = '加载中...') {
    if (show) {
        Dialog.loading.open(text);
    }
    else {
        Dialog.loading.close();
    }
};
Vue.prototype.$showError = function (text) {
    Dialog.alert({
        message: text,
    });

};

Vue.prototype.$showSuccess = function (text, timeout = 1500) {
    Dialog.alert({
        message: text,
    });

};


// ================================= 自定义组件 ================================= //
Vue.component('navBar', NavBar);
// Vue.component('FormItem', FormItem);
// Vue.component('GridView', GridView);
// Vue.component('GridItem', GridItem);
// Vue.component('AdView', AdView);
Vue.component('yd-layout', Page);


// Vue.directive('anchor',{
//     inserted : function(el,binding){
//         el.onclick = function(){
//             document.documentElement.scrollTop = $('#anchor-'+binding.value).offset().top
//         }
//     }
// })


// ================================= 状态管理 ================================= //
// vuex
Vue.prototype.$login = function (user) {
    this.$store.commit(USER_LOGIN, user);
    this.$router.replace('/main');
};


// ================================= 路由配置 ================================= //
// push操作
Vue.prototype.$push = function (route, params = {}) {
    // console.log(params);
    router.push({path: route, params})
};
Vue.prototype.$pushRoute = function (route, params = {}) {
    // console.log(params);
    router.push({name: route, params})
};
// pop操作
Vue.prototype.$pop = function () {
    router.back()
};

// ================================= API请求 ================================= //
Vue.prototype.$post = function (url, param) {

    let headers = {
        token: store.state.user.user ? store.state.user.user.token : '',
    }
    if (process.env.NODE_ENV === 'production') {
        return api.POST(url, headers, param);
    }
    else {
        // console.log(`=========== 数据请求【${url}】 ============`)
        // console.log('headers：' + JSON.stringify(headers));
        // console.log('参数：' + JSON.stringify(param));
        return new Promise((resolve, reject)=> {
            "use strict";
            api.POST(url, headers, param).then(res=> {
                // console.log('返回值：', res);
                resolve(res);
            });
        });
    }
};

// ================================= 自定义 ================================= //
Vue.prototype.$config = function (key) {
    return Config[key] || '';
};


// ================================= 其他配置 ================================= //
Vue.config.productionTip = false;

// =================================== 使用Navigation ================================== //
// Vue.use(Navigation, {router, store});

// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})
new Vue({
    el: '#app',
    store,
    router,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js